import Loadable from 'react-loadable'
import LoadingIndicatorFull from '../LoadingIndicatorFull.js'

const LoadableDashboard = Loadable({
  loader: () => import('./Dashboard.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableDashboard
